<template>
  
    <v-dialog v-model="isOpen" max-width="800px" scrollable persistent>
     
      <v-card>
        <v-card-title  :class="['dialog-title',  this.$gf.headerColor()]" dark >

         
          <span>{{ this.dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container class="dialog-container">
            <v-simple-table dense class="mt-5">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>
                        First Name
                      </th>
                      <th>
                        Last Name
                      </th>
                      <th>
                        Email
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item,index) in dialogData"
                      :key="index"
                    >

                      <td>{{ item.first_name }}</td>
                      <td>{{ item.last_name }}</td>
                      <td><a :href="'mailto:' + item.email">{{ item.email }}</a></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
          </v-container>
        </v-card-text>
        <v-card-actions class="btn-section">
          <v-btn class="mr-1 mb-2 "
          color="primary"  @click="closeDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    
    </v-dialog>
  
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    dialogTitle: {
      type: String,
      required: true
    },
    dialogData: {
      type: Array,
      required: true
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    }
  }
};
</script>